export const DsSvgIconDefaultProps = {
    fontSize: 'mild',
    color: 'iconActionSecondary'
};
